import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    createExerciseCategory,
    updateExerciseCategory,
    clearMessages as clearExerciseMessages
} from '../../../redux/slices/admin/exerciseCategorySlice'; // Adjust the import path as necessary

const ExerciseModal = ({ isOpen, closeModal, initialData, isEditMode }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        category_name: ''
    });

    const successMessage = useSelector((state) => state.exerciseCategories?.successMessage);
    const errorMessage = useSelector((state) => state.exerciseCategories?.error);

    useEffect(() => {
        if (isEditMode && initialData) {
            setFormData({
                category_name: initialData.category_name || ''
            });
        }
    }, [isEditMode, initialData]);

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        const payload = {
            id: isEditMode ? initialData.id : undefined, // Include id if editing
            category_name: formData.category_name
        };

        if (isEditMode) {
            await dispatch(updateExerciseCategory(payload)); // Send payload directly
        } else {
            await dispatch(createExerciseCategory(payload)); // Send payload directly
        }
    };

    const handleClose = () => {
        dispatch(clearExerciseMessages());
        // Clear the form data only when the modal is closed
        setFormData({
            category_name: ''
        });
        closeModal();
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', paddingLeft: '0px' }}>
            <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-create">
                <div className="modal-content">
                    <div className="modal-header justify-content-center">
                        <h1 className="modal-title" id="modalExerciseLabel">{isEditMode ? 'Edit Category' : 'Create New Category'}</h1>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <form onSubmit={handleFormSubmit}>
                        <div className="modal-body px-md-5 pb-md-4">
                            <div className="row g-3 gx-md-5 gy-md-4">
                                <div className="col-md-12">
                                    <input
                                        type="text"
                                        placeholder="Title"
                                        className="form-control form-control-lg"
                                        name="category_name"
                                        value={formData.category_name}
                                        onChange={handleFormChange}
                                        required
                                    />
                                </div>
                                
                                <div className="col-md-12">
                                    <button type="submit" className="btn btn-create w-100">{isEditMode ? 'Update' : 'Create'}</button>
                                    {successMessage && <div className="alert alert-success mt-3">{successMessage}</div>}
                                    {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ExerciseModal;